import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';

import { MilestoneCard_cardQuery$key } from './__generated__/MilestoneCard_cardQuery.graphql';
import { MilestoneProps, MilestoneFormProps } from './types';

export const Milestone: ComponentType<MilestoneProps> & LoadableExport.LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: 'milestone' */ './Milestone'),
	loading: () => null,
});

export const MilestoneForm: ComponentType<MilestoneFormProps> & LoadableExport.LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: 'milestonesForm' */ './MilestonesForm'),
	loading: () => null,
});

export const MilestoneCard: ComponentType<{
    data: MilestoneCard_cardQuery$key;
}> & LoadableExport.LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: 'milestoneCard' */ './MilestoneCard'),
	loading: () => null,
});
